module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-floral-5-dd8e63061fb5be4db1f6e37c6aafd2b5.webp";